import type VueRouter from 'vue-router';
import type { NavigationGuardNext, Route } from 'vue-router';
import { EventAction, EventApi, SdkClient } from '@rready/sdk';
import type { IEvent } from '@rready/sdk';
import { resolveProduct } from './resolver';
import { useContextStore } from '../../store/contextStore';
import { SdkOptions } from '../../plugins/SdkConfiguration';
import { useAiAgentStore } from '../../store/aiAgentStore';

export function routerNavigateUp(
  router: VueRouter,
  params?: Record<string, string>
): Promise<Route> {
  const matchingRoutes = router.currentRoute.matched;
  const parentName = matchingRoutes[matchingRoutes.length - 2].name;

  return router.push({
    name: parentName,
    params
  });
}

export function applyTitleUpdater(
  to: Route,
  from: Route,
  next: NavigationGuardNext
) {
  const title = to.meta?.title;
  const pageId = to.params?.id || to.params?.sectionLabel;
  const product =
    resolveProduct()?.toUpperCase() ?? to.path.split('/')[1]?.toUpperCase();

  let documentTitle = `${product}`;
  if (title) {
    documentTitle = `${documentTitle} - ${title}`;
  }
  if (pageId) {
    documentTitle = `${documentTitle} - ${pageId}`;
  }
  document.title = documentTitle;
  next();
}

export function sendKibanaPageEvent(
  to: Route,
  from: Route,
  next: NavigationGuardNext
) {
  const product =
    resolveProduct()?.toUpperCase() ?? to.path.split('/')[1]?.toUpperCase();
  if (!product) {
    next();
    return;
  }

  const toPath = to.fullPath;
  const fromPath = from.fullPath;
  const pageEvent: IEvent = {
    action: EventAction.load,
    type: 'page',
    meta: {
      toPath,
      fromPath,
      product
    }
  };
  const sdkApiEvent = new EventApi(new SdkClient(SdkOptions));
  // Context doesn't exist in the SDK yet on initial app load,
  // so we pass it in manually
  const context = useContextStore().contextId;
  sdkApiEvent.sendEvent(pageEvent, context!, product?.toLowerCase());

  next();
}

export function resetAiAgentContext(
  to: Route,
  from: Route,
  next: NavigationGuardNext
) {
  useAiAgentStore().resetContext();
  next();
}
